'use client';

import Footer from "@/components/footer";
import Header from "@/components/header";
import GastronomicalExperience from "@/components/gastronomicalExperience";
import Location from "@/components/location";
import Link from "next/link";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsRight, faPlay, faMugSaucer } from '@fortawesome/pro-solid-svg-icons';
import EventsExperiencesOrange from "@/components/eventsExperiencesOrange";
import Quotation from "@/components/quotation";
import { useParams } from "next/navigation";

export default function Instalaciones()  {
  const params = useParams<{ section: string }>();

  return (
    <>
      <Header sectionName={"instalaciones"} />
      <main className="mt-24 md:mt-32">
        <section className="relative mx-auto py-4 md:px-0">
          <div className="md:relative mr-5 px-8 pt-24 pb-36 bg-[#FBF9F2]/95 rounded-tr-[100px] flex flex-col gap-6 text-center items-center">
            <Image src="/images/lines/halfCircles.svg" alt="decoration" width={240} height={24} className=""/>
            <h1 className="px-8 font-thin text-2xl max-w-[900px] md:text-4xl">Conocé el mejor lugar para <span className="font-bold">aprender Gastronomía en la región</span></h1>
            <p className="py-1 max-w-lg font-thin text-md">Más de 2000m2 dedicados <span className="font-bold">exclusivamente</span> a la enseñanza culinaria y experiencias gastronómicas</p>
            <div className="flex flex-col gap-4 md:flex-row items-center">
              <Link href='https://wa.me/50662236864' className="font-bold text-sm rounded-full py-4 px-8 mr-4 shadow-sm border-2 border-[#FECB1C] hover:bg-[#FECB1C]/15 md:text-nowrap">
                Agendá una visita
                <FontAwesomeIcon icon={faChevronsRight} className="text-[9px] ml-2"/>
              </Link>
              {/* <Link href="#" className="flex items-center gap-2 py-4">
                <div className="font-bold text-sm rounded-full py-4 px-5 mr-2 shadow-sm bg-[#FBA919] hover:bg-[#FBA919]/85 md:text-nowrap">
                  <FontAwesomeIcon icon={faPlay} className="text-white"/>
                </div>
                <span className="font-bold hover:text-gray-600">Ver video</span>
              </Link> */}
            </div>
          </div>
          <div className="relative -mt-32 md:-mt-24 flex justify-center items-center">
            <Image src="/images/heroes/instalaciones.jpg" alt="instalaciones" width={850} height={201} priority fetchPriority="high" className="relative z-10"/>
            <Image src="/images/decoration/dottedShape.png" alt="decoration" width={200} height={200} className="hidden md:block absolute -top-6 inset-x-2/3 z-0"/>
            <Image src="/images/decoration/dottedShape.png" alt="decoration" width={200} height={200} className="hidden md:block absolute bottom-44 inset-x-1/4 z-0"/>
            <Image src="/images/decoration/360.png" alt="decoration" width={100} height={100} className="hidden md:block absolute top-44 right-100 z-10"/>
            <Link href="https://tour.amura.cr/" target='_blank' className=" hover:bg-gray-400/40 absolute top-5 lg:top-64 right-100 z-10 font-bold text-white text-sm rounded-full py-4 px-10 bg-gray-200/40 backdrop-blur-md shadow-sm border-2 border-[#FEC93E] md:text-nowrap mt-8 md:mt-2">
              Tomar un Tour 360
              <FontAwesomeIcon icon={faChevronsRight} className="text-[9px] ml-2"/>
            </Link>
          </div>
        </section>
        <EventsExperiencesOrange />
        <Quotation sectionName={"instalaciones"} />
        <Location sectionName={"instalaciones"} />
        <GastronomicalExperience />
      </main>
      <Footer sectionName={""} />
    </>
  )
}